import React from 'react'

export default function PendingInvitation() {
  return <div>PendingInvitation</div>
}
